import { jsx as _jsx } from "react/jsx-runtime";
import DetailedTermSelector from 'pricing-pages-ui/components/common/DetailedTermSelector';
import Whitespace from 'pricing-pages-ui/components/common/Whitespace';
import { crmSuiteAvailableTermsSelector } from 'pricing-pages-ui/selectors/OfferSelectors';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { currentSuiteSkuIdsForProductLevelSelector } from '../../selectors/ProductsSelectors';
const StyledTermSelectorContainer = styled(DetailedTermSelector).withConfig({
  displayName: "SuiteTermSelectorContainer__StyledTermSelectorContainer",
  componentId: "sc-178heh8-0"
})(["margin:0 auto;"]);

const SuiteTermSelectorContainer = ({
  queryParamTerm,
  productLevel,
  onChange,
  trackingSource,
  isStarterSuiteGWP = false
}) => {
  const skuIds = useSelector(reduxState => {
    return currentSuiteSkuIdsForProductLevelSelector(reduxState, {
      productLevel
    });
  });
  const hasMultipleTerms = useSelector(reduxState => crmSuiteAvailableTermsSelector(reduxState, {
    productLevel
  })).length > 1;

  if (!hasMultipleTerms) {
    return /*#__PURE__*/_jsx(Whitespace, {
      height: 41
    });
  }

  const trackingSourceString = `${trackingSource}-${productLevel.toLowerCase()}`;
  return /*#__PURE__*/_jsx(StyledTermSelectorContainer, {
    skuIds: skuIds,
    onChange: onChange,
    trackingSource: trackingSourceString,
    activeTerm: queryParamTerm,
    screen: NavItemEnum.SUITE,
    isStarterSuiteGWP: isStarterSuiteGWP
  });
};

export default SuiteTermSelectorContainer;